import { useQuery } from "@tanstack/react-query";
import { physicalClientsApi } from "@/lib/api";
import { physicalClientHistoryQueryKey } from "./physicalClientQueryKeys";

/**
 * Histórico do cliente PF, mais recente primeiro. A aba "Histórico" e o aviso de situação do cabeçalho usam a mesma
 * query (mesma chave e mesma função), então dividem o cache e fazem uma requisição só.
 */
export function usePhysicalClientHistory(physicalClientId: number, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: physicalClientHistoryQueryKey(physicalClientId),
    queryFn: async () => (await physicalClientsApi.getHistory(physicalClientId)).data ?? [],
    enabled: options.enabled ?? true,
  });
}
